import React, { memo } from 'react';

const SalesComponent = ({ data }) => <div>${data.companyRevenue}</div>;

export const Sales = memo(SalesComponent);
